import { GeneralObject } from '~/types/CommonTypes';
import { MySsApiResponse } from '~/types/MySsApiResponse';
import { TransactionListFiltersDto } from '~/models/Transaction';
import { RedemptionsListFilters } from '~/models/Redemptions/RedemptionsListFilters';
import { errorTreatment } from '~/utils/ExceptionHandler';
import { downloadFileBlob } from '~/utils/dataUtils';

import HttpService from '~/services/httpService';
import { ApiResponse } from '~/types/ApiResponse';
import CommissionsListItem from '~/pages/commissions/CommissionsListItem.vue';

const get = HttpService.get;
const post = HttpService.post;

const baseUrl = 'rewards-accounts';

export async function getBalance(companyDocument: string) {
  return await get(`${baseUrl}/${companyDocument}/balance`, {}).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}
export async function getTransactions(
  companyDocument: string,
  params?: TransactionListFiltersDto,
) {
  const finalParams = params ?? { ...new TransactionListFiltersDto() };

  return await get(`${baseUrl}/${companyDocument}/transactions`, { params: finalParams })
    .then((data: ApiResponse) => ({
      items: data.data.data || [],
      pagination: data.data.metadata?.pagination || {},
      success: data.data.success || false,
    }))
    .catch((err) => { throw err });
}


export async function getRedemptions(companyDocument: string, params: GeneralObject = {}) {
  return await get(`${baseUrl}/${companyDocument}/redemptions`, { params }).then(
    (data: ApiResponse) => {
      const items = data.data.data || [];
      let pagination = {};
      if (
        data.data.metadata &&
        typeof data.data.metadata === 'object' &&
        'pagination' in (data.data.metadata as Record<string, unknown>)
      ) {
        pagination = (data.data.metadata as { pagination?: unknown }).pagination || {};
      }
      return {
        items,
        pagination,
        success: data.data.success || false,
      };
    }
  ).catch((err) => {throw err})
}

export async function getRewardsAccounts(companyDocument: string) {
  return await get(`${baseUrl}/${companyDocument}`, {
    params: { rewardProgramCodeType: 'Commissions' },
  }).then(({ data }: MySsApiResponse) => data);
}

export async function makeARansomRequest(params: FormData) {
  return await post(`rewards-accounts/redemptions`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(
    (response) => {
      return response.data;
    },
    (error) => {
      throw error;
    },
  );
}

export async function downloadAllTransactions(
  companyDocument: string,
  params: TransactionListFiltersDto = { ...new TransactionListFiltersDto() },
) {
  try {
    return await get(`${baseUrl}/${companyDocument}/transactions/export`, {
      params,
      responseType: 'blob',
    }).then(
      ({ data }: any) => {
        downloadFileBlob(data, `MINHACONTA_MEUS LANCAMENTOS.xlsx`);
      },
      (error: any) => {
        throw errorTreatment(error);
      },
    );
  } catch (error: any) {
    const err = errorTreatment(error);
    throw err;
  }
}

export async function downloadAllRedemptions(
  companyDocument: string,
  params: RedemptionsListFilters = { ...new RedemptionsListFilters() },
) {
  try {
    return await get(`${baseUrl}/${companyDocument}/redemptions/export`, {
      params,
      responseType: 'blob',
    }).then(
      ({ data }: any) => {
        downloadFileBlob(data, `MINHACONTA_MEUSRESGATES.xlsx`);
      },
      (error: any) => {
        throw errorTreatment(error);
      },
    );
  } catch (error: any) {
    const err = errorTreatment(error);
    throw err;
  }
}
